import React from 'react';
import { CartData } from 'src/scripts/utils/cart';
import { pluralize } from 'src/scripts/utils/helpers';

export type PurchaseLimitTagDataTypes = {
  purchaseLimitType: string;
  purchaseLimitNumber: number;
};

export function extractPurchaseLimitTagData(tags: string[] | undefined): PurchaseLimitTagDataTypes | undefined {
  const purchaseLimitTag = tags && tags.find((tag) => tag.includes('purchaselimit'));
  const purchaseLimitValues = purchaseLimitTag && purchaseLimitTag.split(':');
  const purchaseLimitType = purchaseLimitValues && purchaseLimitValues[1];
  if (purchaseLimitValues && purchaseLimitType) {
    const purchaseLimitNumber = purchaseLimitValues && Number(purchaseLimitValues?.[2]);
    const purchaseLimitTagData: PurchaseLimitTagDataTypes = { purchaseLimitType, purchaseLimitNumber };
    return purchaseLimitTagData;
  } else {
    return undefined;
  }
}

export function hasMetLimitedProductCartQuantity(
  cartData: CartData,
  variantToCompare: string | undefined,
  purchaseLimitTagData: PurchaseLimitTagDataTypes
): boolean {
  if (purchaseLimitTagData) {
    const selectedSku = variantToCompare;
    if (!selectedSku) {
      return false;
    }
    return cartData.regularItems.some((item) => {
      const itemSku = item.sku;
      if (itemSku === selectedSku) {
        return item.quantity <= purchaseLimitTagData.purchaseLimitNumber;
      }
      return false;
    });
  }
  return false;
}

const PurchaseLimitMessaging = ({
  purchaseLimitTagData,
  messageType,
}: {
  purchaseLimitTagData: PurchaseLimitTagDataTypes;
  messageType?: 'default' | 'alreadyInBag' | 'variant';
}) => {
  const { purchaseLimitNumber } = purchaseLimitTagData;
  const message = `${
    messageType === 'alreadyInBag'
      ? `This product is limited to ${purchaseLimitNumber} per order and ${
          purchaseLimitNumber && purchaseLimitNumber > 1 ? `are` : `is`
        } in your bag.`
      : messageType === 'variant'
      ? `${pluralize(purchaseLimitNumber, 'Size')} Per Order`
      : `Limited to ${purchaseLimitNumber} per order.`
  }`;
  if (purchaseLimitNumber && purchaseLimitNumber !== 0) {
    return <p className="purchase-limit-text body-small red tooltip mb-0">{message}</p>;
  } else {
    return null;
  }
};

export default PurchaseLimitMessaging;
